<template>
  <div class="checkout">
    <v-alert
      class="alert-cart"
      height="50"
      transition="fade-transition"
      v-model="alertaValidacion"
      color="red"
    >
      <span>{{mensajeErrorEnValidacion}}</span>
      <div class="centrar-right"></div>
    </v-alert>

    <v-container style="padding-top: 70px; min-height: calc(100vh - 350px);" class="pb-sm-8 pb-0">
      <v-row align="center">
        <v-col cols="12" sm="3">
          <v-breadcrumbs :items="items" divider="|" class="px-0"></v-breadcrumbs>
        </v-col>
        <v-col cols="12" sm="6" class="text-center">
          <h1 class="titulo">RESUMEN DE COMPRA</h1>
        </v-col>
      </v-row>

      <v-row align="center" class="mb-8 d-none d-sm-flex">
        <v-spacer></v-spacer>
        <v-col class="text-center" cols="auto">
          <span class="d-inline-block titulo gris" style="width: 250px">1. SESIÓN</span>
        </v-col>
        <v-spacer>
          <hr />
        </v-spacer>
        <v-spacer>
          <hr />
        </v-spacer>
        <v-col class="text-center" cols="auto">
          <span class="d-inline-block titulo gris" style="width: 250px">2. DATOS DE ENVIO</span>
        </v-col>
        <v-spacer>
          <hr />
        </v-spacer>
        <v-spacer>
          <hr />
        </v-spacer>
        <v-col class="text-center" cols="auto">
          <span class="d-inline-block titulo verde-oscuro" style="width: 250px">3. TIPO DE PAGO</span>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>

      <v-row class="d-md-none" align="center">
        <v-col class="text-center" cols="auto">
          <v-avatar color="#D8D8D8">
            <span>1</span>
          </v-avatar>
        </v-col>
        <v-spacer>
          <hr />
        </v-spacer>

        <v-col cols="auto" class="text-center">
          <v-avatar color="#D8D8D8">
            <span>2</span>
          </v-avatar>
        </v-col>
        <v-spacer>
          <hr />
        </v-spacer>
        <v-col cols="auto" class="text-center">
          <v-avatar color="#03241D">
            <span class="white--text">3</span>
          </v-avatar>
        </v-col>
      </v-row>

      <div class="animated fadeIn">
        <v-row>
          <v-col class="text-center">
            <span class="subtitulo verde-oscuro uppercase">Resumen de compra</span>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="12" xl="9">
            <v-row class="d-none d-md-flex" style="background-color: #E2D4CA;">
              <v-col
                cols="10"
                style="border: 1px solid #979797; border-right: none; border-bottom: none; background-color: white;"
              >
                <v-row>
                  <v-col>
                    <span
                      class="modernist-bold"
                      style="color: #03241D; font-size: 12px;"
                    >Descripción</span>
                  </v-col>
                  <!-- <v-col>
                    <span class="modernist-bold" style="color: #03241D; font-size: 12px;">Cantidad</span>
                  </v-col> -->
                  <!-- <v-col>
                    <span
                      class="modernist-bold"
                      style="color: #03241D; font-size: 12px;"
                    >Precio Unitario</span>
                  </v-col> -->
                </v-row>
              </v-col>
              <v-col cols="2" align-self="center" class="text-center">Precio Final</v-col>
            </v-row>

            <v-row class="d-none d-md-flex mb-6" align="center" style="background-color: #E2D4CA;">
              <v-col
                cols="10"
                style="border: 1px solid #979797; border-right: none; background-color: white;"
              >
                <v-row>
                    <v-col>
                        <span class="d-inline-block mr-3">{{regalo.NombreComun}}</span>
                        <span class="d-inline-block">{{regalo.NombreCientifico}}</span>
                        <div>
                            <div class="d-inline-block mr-2">
                            <b style="font-size: 12px; color:#03241d">Tamaño:</b>
                            <span style="text-transform: uppercase;font-size: 12px; color:#03241d">
                                {{regalo.Tamano}}
                            </span>
                            </div>
                            <div class="d-inline-block mr-2" >
                                <b style="font-size: 12px; color:#03241d">Maceta:</b>
                                <span style="font-size: 12px; color:#03241d">{{regalo.Nombre}}</span>
                            </div>
                            <div class="d-inline-block mr-2" v-if="regalo.Base != null">
                            <b style="font-size: 12px; color:#03241d">Base:</b>
                            <span style="font-size: 12px; color:#03241d">{{regalo.Base[0].Nombre}}</span>
                            </div>
                        </div>
                    </v-col>
                </v-row>

                
              </v-col>
              <v-col cols="2" class="text-center">
                <span
                  class="modernist-bold"
                  style="font-size: 16px; color: #03241D"
                >TOTAL: ${{regalo.Precio}}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <div class="d-md-none">

            <v-row>
                <v-col>
                    <span class="d-inline-block mr-3">{{regalo.NombreComun}}</span>
                    <span class="d-inline-block">{{regalo.NombreCientifico}}</span>
                    <div>
                        <div class="d-inline-block mr-2">
                        <b style="font-size: 12px; color:#03241d">Tamaño:</b>
                        <span style="text-transform: uppercase;font-size: 12px; color:#03241d">
                            {{regalo.Tamano}}
                        </span>
                        </div>
                        <div class="d-inline-block mr-2" >
                            <b style="font-size: 12px; color:#03241d">Maceta:</b>
                            <span style="font-size: 12px; color:#03241d">{{regalo.Nombre}}</span>
                        </div>
                        <div class="d-inline-block mr-2" v-if="regalo.Base != null">
                        <b style="font-size: 12px; color:#03241d">Base:</b>
                        <span style="font-size: 12px; color:#03241d">{{regalo.Base[0].Nombre}}</span>
                        </div>
                    </div>
                </v-col>
            </v-row>
          
        </div>
      </div>

      <v-row class="d-md-none" style="background-color: #E2D4CA;">
        <v-col cols="6" class="text-center">
          <span class="modernist-bold" style="font-size: 16px; color: #03241D">TOTAL:</span>
        </v-col>
        <v-col cols="6" class="text-center">
          <span class="modernist-bold" style="font-size: 16px; color: #03241D">${{regalo.Precio}}</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="text-center">
          <span class="subtitulo verde-oscuro uppercase">Elige tu tipo de pago</span>
        </v-col>
      </v-row>

      <v-row justify="center">
        <v-col cols="12" sm="4" md="4" lg="3" xl="2" class="text-center">
          <PayPal
            :amount="regalo.Precio.toString()"
            currency="MXN"
            :client="paypal"
            :items="myItems"
            
            :button-style="myStyle"
            @payment-completed="payment_completed_cb"
            :experience="experienceOptions"
          ></PayPal>
        </v-col>

        <v-col cols="12" sm="4" md="4" lg="3" xl="2" class="text-center">
          <v-btn
            elevation="0"
            dark
            color="#03241D"
            tile
            block
            :ripple="false"
            @click="formulario_conekta = true;"
          >
            <span style="font-size: 12px;">TARJETA DE DÉBITO O CRÉDITO</span>
          </v-btn>
        </v-col>
      </v-row>

      <transition name="fade-transition">
        <v-row justify="center" v-if="formulario_conekta" class="my-12">
          <v-col cols="10" sm="8" md="6">
            <span
              class="subtitulo verde-oscuro uppercase d-inline-block mb-6"
            >DATOS DE TARJETA DE CRÉDITO O DÉBITO</span>
            <v-form id="forma">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Nombre del Tarjetahabiente"
                    v-model="datos_tarjeta.nombre"
                    data-conekta="card[name]"
                    color="#03241D"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Numero de Tarjeta"
                    v-model="datos_tarjeta.numero"
                    data-conekta="card[number]"
                    color="#03241D"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" md="2">
                  <v-text-field
                    label="Mes Exp."
                    v-model="datos_tarjeta.mes"
                    data-conekta="card[exp_month]"
                    placeholder="MM"
                    color="#03241D"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" md="2">
                  <v-text-field
                    label="Año Exp."
                    v-model="datos_tarjeta.year"
                    data-conekta="card[exp_year]"
                    placeholder="AAAA"
                    color="#03241D"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" md="2">
                  <v-text-field
                    label="CVV"
                    v-model="datos_tarjeta.cvv"
                    data-conekta="card[cvc]"
                    color="#03241D"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-btn
                @click="realizarPago"
                color="#03241D"
                dark
                block
                tile
                elevation="0"
                :ripple="false"
              >
                <span style="font-size: 12px;">Pagar ahora</span>
              </v-btn>
            </v-form>
          </v-col>
        </v-row>
      </transition>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import PayPal from "vue-paypal-checkout";
export default {
  data: () => ({
    items: [
      {
        text: "Inicio",
        disabled: false,
        to: "/"
      },
      {
        text: "Cesta de Compra",
        disabled: false,
        to: "/cart"
      },
      {
        text: "Tramitar pedido",
        disabled: true
      },
      {
        text: "Tipo de pago",
        disabled: true
      }
    ],
    myStyle: {
      label: "checkout",
      size: "responsive",
      shape: "pill",
      color: "blue"
    },
    experienceOptions: {
      name: "Chlorophilia",
      presentation: {
        logo_image:
          "https://developer.paypal.com/components/dx/img/logo-PayPal-Developer.svg"
      }
    },
    cart: [],
    paypal: {
      sandbox:
        "AXgJYI7bP62-aC7dC9Lj8V1wY9VsMdyHmJoMPSdovXos_l6iC0CNpcqPqxua1k9KJ4BiG7lJahGk339z",
      production:
        "AbfLF6pzZqzv4funx1y9jfHS2Tv2-AhzNf9BiHm40ZjITARFW0ekJz9fbvL637SJm-AE1imsQZF2742W"
    },
    myItems: [],
    personal: {},
    factura: {},
    envio: {},
    codigo_descuento: {},
    datos_tarjeta: {
      nombre: "",
      numero: "",
      cvv: "",
      mes: "",
      year: ""
    },
    // datos_tarjeta: {
    //   nombre: "Eugenio",
    //   numero: "4117441852871209",
    //   cvv: "657",
    //   mes: "06",
    //   year: "2023"
    // },
    token_tarjeta: "",
    parametros_conekta: {
      line_items: [],
      currency: "MXN",
      customer_info: {},
      shipping_contact: {},
      metadata: {
        reference: "12987324097",
        more_info: "lalalalala"
      },

      charges: [],
      amount: 34000
    },
    uid: "",
    formulario_conekta: false,
    alertaValidacion: false,
    mensajeErrorEnValidacion: "",
    pedido: {},
    regalo: {},
    token_aceptado: 0
  }),
  components: {
    PayPal
  },
  computed: {
    total: function() {
      var total = this.regalo.Precio;

    //   for (var x = 0; x < this.cart.length; x++) {
    //     total += this.cart[x].precio * this.cart[x].cantidad;
    //   }

      return total;
    }
  },
  methods: {
    pago_completo: function(n, e) {
      console.log("pago completo");
      console.log(n);
      console.log(e);
    },
    payment_completed_cb(res, planName) {
      console.log(res);
      console.log(planName);
      this.pedido.PagadoCon = 'PayPal';
      this.pedido.ReferenciaPago = res.id;
      var aux = this;
      axios({
        method: "POST",
        baseURL: "https://strapi.actstudio.xyz/pedidos",
        data: this.pedido
      }).then(function(res){
        console.log(res);

        axios({
          method: "GET",
          baseURL: "https://chlorophilia.com/correo_venta_regalo.php?referencia="+aux.uid,
        }).then(function(rest){
          aux.$session.remove('cart');
          console.log(rest)
          aux.$router.push("/checkout/completo");
        });
      });

    },
    calcular_total: function() {
      var total = this.regalo.Precio;

    //   for (var x = 0; x < this.cart.length; x++) {
    //     total += this.cart[x].precio * this.cart[x].cantidad;
    //   }

    //   if (this.codigo_descuento.descuento_general != null) {
    //     return (
    //       total *
    //       (1 - this.codigo_descuento.descuento_general.PorcentajeDescuento)
    //     );
    //   } else {
    //     return total;
    //   }
    },
    conektaSuccessResponseHandler: function(token) {
      this.token_tarjeta = token.id;
      this.parametros_conekta.charges[0].payment_method.token_id = token.id;
      this.token_aceptado = 1;
    },
    conektaErrorResponseHandler: function(token) {
      console.log(token);
      this.mensajeErrorEnValidacion = token.message_to_purchaser;
      this.alertaValidacion = true;
      setTimeout(() => {
        this.alertaValidacion = false;
      }, 5000);
      this.token_aceptado = 0;
    },
    realizarPago: function() {
      Conekta.setPublicKey("key_bT45eK1kw7ogPJYa49YAYdg");

      var $form = $("#forma");
      // Previene hacer submit más de una vez
      Conekta.Token.create(
        $form,
        this.conektaSuccessResponseHandler,
        this.conektaErrorResponseHandler
      );

      if(this.token_aceptado == 1){
      
        var aux = this;
        setTimeout(() => {
          axios({
            method: "POST",
            baseURL: "https://chlorophilia.com/conekta.php",
            data: this.parametros_conekta
          }).then(function(res){
            if(res.data.payment_status == 'paid'){
              
              aux.pedido.PagadoCon = 'Conekta';
              aux.pedido.ReferenciaPago = res.data.id;
              axios({
                method: "POST",
                baseURL: "https://strapi.actstudio.xyz/pedidos",
                data: aux.pedido
              }).then(function(res){
                axios({
                  method: "GET",
                  baseURL: "https://chlorophilia.com/correo_venta_regalo.php?referencia="+aux.uid,
                }).then(function(rest){
                  console.log(rest)
                  aux.$session.remove('cart');
                  aux.$router.push("/checkout/completo");
                });
              });
          


            }
            console.log(res)
          });
        }, 1000);
      }
    }
  },
  created: function() {

    this.regalo = this.$session.get('regalo');

    this.uid = Date.now();
    this.cart = this.$session.get("cart");

    this.envio = this.$session.get("envio");
    this.factura = this.$session.get("factura");
    this.personal = this.$session.get("personal");

    var elemento = {
        name: this.regalo.NombreComun + ' ' + this.regalo.NombreCientifico,
        description: this.regalo.Nombre,
        quantity: 1,
        price: this.regalo.Precio,
        currency: 'MXN'
    };

    this.myItems.push(elemento);

    var elemento_conekta = {
        name: this.regalo.NombreComun + ' ' + this.regalo.NombreCientifico,
        unit_price: this.regalo.Precio * 100,
        quantity: 1
    };

    this.parametros_conekta.line_items.push(elemento_conekta);

    // for (let n_item = 0; n_item < this.cart.length; n_item++) {
    //   var elemento = {
    //     name: this.cart[n_item].producto.NombreComun,
    //     description: "Brown hat." + n_item,
    //     quantity: this.cart[n_item].cantidad.toString(),
    //     price: this.cart[n_item].precio.toString(),
    //     currency: "MXN"
    //   };

    //   this.myItems.push(elemento);

    //   var elemento_conekta = {
    //     name: this.cart[n_item].producto.NombreComun,
    //     unit_price: this.cart[n_item].precio * 100,
    //     quantity: this.cart[n_item].cantidad
    //   };

    //   this.parametros_conekta.line_items.push(elemento_conekta);
    // }

    this.parametros_conekta.customer_info = {
      name: this.personal.nombre,
      email: this.personal.email,
      phone: this.personal.telefono
    };

    this.parametros_conekta.shipping_contact = {
      address: {
        street1: this.envio.direccion + " " + this.envio.numero,
        postal_code: this.envio.codigo_postal,
        country: "MX"
      }
    };

    this.parametros_conekta.metadata = {
      reference: this.uid
    };

    this.parametros_conekta.charges.push({
      payment_method: {
        type: "card"
      },
      livemode: false,
      amount: this.regalo.Precio * 100
    });

    if (
      this.$session.exists("codigo_descuento") &&
      this.$session.get("codigo_descuento") != undefined
    ) {
      // this.codigo_descuento = this.$session.get("codigo_descuento");
      var aux = {
        descuento_general: null,
        descuento_especifico: null,
        descuento_producto: null
      };

      this.$session.set("codigo_descuento", aux);
    } else {
      var aux = {
        descuento_general: null,
        descuento_especifico: null,
        descuento_producto: null
      };

      this.$session.set("codigo_descuento", aux);
    }


    var pedido = {
        CorreoElectronico: this.personal.email,
        Nombre: this.personal.nombre,
        Telefono: this.personal.telefono,
        De: this.personal.de,
        Para: this.personal.para,
        Mensaje: this.personal.mensaje,
        EnvioCalle: this.envio.direccion,
        EnvioNumeroExterior: this.envio.numero,
        EnvioNumeroInterior: this.envio.numero_interno,
        EnvioReferencias: this.envio.referencia,
        EnvioColonia: this.envio.colonia,
        EnvioCiudad: this.envio.municipio,
        EnvioCodigoPostal: this.envio.codigo_postal,
        EnvioEstado: this.envio.estado,
        EnvioPais: this.envio.pais,
        EnvioPreferenciaEntrega: this.envio.preferencia_entrega,
        Items: [],
        CantidadProductos: 0,
        Total: 0,
        User: null,
        IdentificadorUnico: this.uid,
        PagadoCon: '',
        ReferenciaPago: '',
        Tipo: 'Regalo'
      };

      if(this.personal.factura){
        pedido = {
          CorreoElectronico: this.personal.email,
          Nombre: this.personal.nombre,
          Telefono: this.personal.telefono,
          De: this.personal.de,
          Para: this.personal.para,
          Mensaje: this.personal.mensaje,
          EnvioCalle: this.envio.direccion,
          EnvioNumeroExterior: this.envio.numero,
          EnvioNumeroInterior: this.envio.numero_interno,
          EnvioReferencias: this.envio.referencia,
          EnvioColonia: this.envio.colonia,
          EnvioCiudad: this.envio.municipio,
          EnvioCodigoPostal: this.envio.codigo_postal,
          EnvioEstado: this.envio.estado,
          EnvioPais: this.envio.pais,
          EnvioPreferenciaEntrega: this.envio.preferencia_entrega,
          FacturaRFC: this.factura.rfc,
          FacturaRazonSocial: this.factura.razon_social,
          FacturaCalle: this.factura.calle,
          FacturaNumeroExterior: this.factura.numero,
          FacturaNumeroInterior: this.factura.numero_interno,
          FacturaColonia: this.factura.colonia,
          FacturaCiudad: this.factura.municipio,
          FacturaCodigoPostal: this.factura.codigo_postal,
          FacturaEstado: this.factura.estado,
          FacturaPais: this.factura.pais,
          FacturaUsoCFDI: this.factura.cfdi,
          IdentificadorUnico: this.uid,
          PagadoCon: '',
          ReferenciaPago: ''
        };
      }

      var items = [];
      var cantidad = 0;
      var total = 0;

    //   for (let index = 0; index < this.cart.length; index++) {
    //     var item = {
    //       NombreProducto: this.cart[index].producto.NombreComun,
    //       Tamano: this.cart[index].size,
    //       Precio: this.cart[index].precio,
    //       Cantidad: this.cart[index].cantidad,
    //       NombreCientifico: this.cart[index].producto.NombreCientifico,
    //       Maceta: '',
    //       Base: ''
    //     }

    //     if(this.cart[index].maceta != null){
    //       item.Maceta = this.cart[index].maceta.Nombre;
    //     }

    //     if(this.cart[index].base != null){
    //       item.Base = this.cart[index].base.Nombre;
    //     }

    //     cantidad += this.cart[index].cantidad;
    //     total = total + (this.cart[index].cantidad * this.cart[index].precio);

    //     items.push(item);
    //   }

      if(this.$session.has('user') && this.$session.get('user') != undefined){

        pedido.User = this.$session.get('user').jwt;
      }

      var items = [];
      var regalo = this.$session.get('regalo');

      var item = {
           NombreProducto: regalo.NombreComun,
           Tamano: regalo.Tamano,
           Precio: regalo.Precio,
           Cantidad: 1,
           NombreCientifico: regalo.NombreCientifico,
           Maceta: regalo.Nombre
         };

         items.push(item);
      console.log(this.$session.get('regalo'));

      pedido.Items = items;
      pedido.CantidadProductos = cantidad;
      pedido.Total = total;

      this.pedido = pedido;
  },
  mounted: function() {
    //emitir evento para ocultarc menú
    this.$emit("updateMenu", 1);
    gtag('config', 'UA-163902944-1', {
      'page_title' : 'Elige Método de Pago en Regalo',
      'page_path': '/CheckoutRegalo/metodo-pago'
    });
  }
};
</script>